function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCopyIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 17.5 17.5",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15,11.15h-.8c-.42,0-.83-.17-1.13-.47-.3-.3-.47-.71-.47-1.13V2.35c0-.42.17-.83.47-1.13.3-.3.71-.47,1.13-.47h7.2c.42,0,.83.17,1.13.47.3.3.47.71.47,1.13v.8M7.95,6.35h7.2c.88,0,1.6.72,1.6,1.6v7.2c0,.88-.72,1.6-1.6,1.6h-7.2c-.88,0-1.6-.72-1.6-1.6v-7.2c0-.88.72-1.6,1.6-1.6Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy_icon.51a585ec.svg";
export { ForwardRef as ReactComponent };